import { useEffect, useState } from "react"
import gsap from "gsap"

const LoadingScreen = () => {
  const [loadingPercentages] = useState([
    0, 2, 8, 16, 20, 44, 58, 60, 81, 92, 100,
  ])

  useEffect(() => {
    const ctx = gsap.context(() => {
      var duration = 1
      let t1 = gsap.timeline()
      loadingPercentages.forEach((prec, i) => {
        t1.set(
          ".precent",
          {
            innerHTML: prec + "%",
          },
          i * duration
        )
      })
      t1.to(".loading-screen", {
        y: "-110%",
        delay: 0.75,
        duration: 1,
        ease: gsap.Expo,
      }).to(".loading-screen", {
        display: "none",
      })
    })

    return () => ctx.revert()
  }, [loadingPercentages])

  return (
    <div className="loading-screen">
      <h1 className="logo uppercase mix-blend-difference title">
        Pixie Autumn
      </h1>
      <p className="logo precent uppercase mix-blend-difference title">0%</p>
    </div>
  )
}

export default LoadingScreen
